import styled from 'styled-components';

const StyledHeader = styled.header`
  position: absolute;
  width: 100%; 
  top: 0;
  z-index: 8;
  .fixed-cta {
    position: fixed;
    bottom: 40px;
    right: 40px;
    background-color: ${props => props.theme.colors.green_secondary};
    z-index: 10;
    border: none;
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    transition: all 0.5s;
    p {
      margin-left: 8px;
      color: #fff;
      max-width: 100px;
      transition: all 0.5s;
      overflow: hidden;
      white-space: nowrap;
    }
    img {
      width: 20px;
    }
    &.small-cta {
      p {
        max-width: 0;
        margin-left: 0;
      }
    }
    &:hover{
      p {
        max-width: 100px;
        margin-left: 8px;
      }
    }
    @media screen and (max-width: 767px){
      bottom: 20px;
      right: 10px;
    }
  }
  .header--wrapper{
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color:#fff;
    z-index: 10;
    padding: 40px 64px 24px;
    color: #000;
    transition: color .25s, background-color .015s;
    &.white--menu{
      color: #fff !important;
      background-color: transparent;
      .rounded--cta{
        border-color: #fff;
        color: #fff;
      }
    }
  }
  a, a:active, a:hover, a:visited,a:link{
    color: inherit !important;
    text-decoration: none;
  }
  .header--main-list-wrap .active{
    position: relative;
  }
  .header--main-list-wrap .active::after{
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    transform: translateX(-50%);
    bottom: -15px;
    left: 50%;
    background-color: #000;
  }
  #sticky--header{
    position: fixed;
    top: 0;
    width: 100%;
    transform: translateY(-100%);
    left: 0;
    transition: transform .25s ease-out;
  }
  #sticky--header.show{
    transform: translateY(0%);
  }
  @media screen and (max-width: 1439px){
    .header--wrapper{
      padding: 24px 40px;
    }
  }
  @media screen and (max-width: 767px){
    .header--wrapper{
      padding: 18px 24px;
    }
  }
  .header--logo-wrap{
    position: relative;
    width: 148px;
    height: 45px;
    display: flex;
    overflow: hidden;
    flex-flow: column nowrap;
  }
  .header--logo-row{
    position: relative;
    flex: 1 0 100%;
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    margin-top: 0;
    transition: margin-top .25s ease-out;
  }
  .back.header--logo-row{
    margin-top: -46px;
  }
  .header--logo-row span{
    cursor: pointer;
  }
  .header--logo-row:nth-child(2){
    justify-content: flex-start;
  }
  .header--logo-wrap img.logo{
    position: absolute;
    display: block;
    width: 100%;
    opacity: 0;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    transition: opacity .25 ease-out;
  }
  .header--logo-wrap img.black-logo{
    opacity: 1;
  }
  .header--logo-wrap img.white-logo{
    opacity: 0;
  }
  .menu--toggle-wrap{
    position: relative;
    width: 44px;
    height: 44px;
    box-sizing: border-box;
    margin-left: 24px;
    display: flex;
    align-items: center;
    cursor: pointer;
    overflow: hidden;
    justify-content: flex-end;
    #menu--toggle{
      position: relative;
      height: 16px;
      width: 22px;
      display: flex;
      justify-content:space-between;
      flex-flow: column wrap;
      align-items: flex-end;
      text-align: right;
    }
    #menu--toggle span{
      height: 2px;
      border-radius: 2px;
      background-color: #000;
      transform: translateX(0);
      opacity: 1;
      transition: transform .25s ease-out, opacity .35s ease-out;
    }
    #menu--toggle span:nth-child(1){
      width: 22px;
    }
    #menu--toggle span:nth-child(2){
      width: 16px;
      transition-delay: .05s;
    }
    #menu--toggle span:nth-child(3){
      width: 8px;
    }
    #menu--toggle.open span:nth-child(1),
    #menu--toggle.open span:nth-child(3){
      transform: translateX(-44px);
      opacity: 0;
    }
    #menu--toggle.open span:nth-child(2){
      transform: translateX(44px);
      opacity: 0;
    }
    .close{
      position: absolute;
      transform: translate(-50%, -50%);
      top: 50%;
      left: 50%;
      width: 12px;
      height: 12px;
    }
    .close::before{
      content: '';
      position: absolute; 
      width: 15px;
      height: 2px;
      background-color: #000;
      transform: translate(-35px,-29px) rotate(45deg);
      opacity: 0;
      top: 50%;
      left: 50%;
      transition: transform .35s ease-out, opacity .25s ease-out ;
    }
    .close::after{
      content: '';
      position: absolute; 
      width: 15px;
      height: 2px;
      background-color: #000;
      transform: translate(35px,-29px) rotate(-45deg);
      opacity: 0;
      top: 50%;
      left: 50%;
      transition: transform .35s ease-out .1s, opacity .25s ease-out;
    }
    #menu--toggle.open .close::before{
      transform: translate(-50%, -50%) rotate(45deg);
      opacity: 1;
    }
    #menu--toggle.open .close::after{
      transform: translate(-50%, -50%) rotate(-45deg);
      opacity: 1;
    }
  }
  .white--menu .header--logo-wrap img.black-logo{
    opacity: 0;
  }
  .white--menu .header--logo-wrap img.white-logo{
    opacity: 1;
  }
  .white--menu #menu--toggle span{
    background-color: #fff;
  }
  .white--menu .header--main-list-wrap .active::after{
    background-color: #fff;
  }
  .header--main-list-wrap{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .header--main-list-wrap p{
    margin: 0 16px;
    transition: color .2s ease-out;
    cursor: pointer;
  }
  
  .header--main-list-wrap p:hover{
    color: ${props => props.theme.colors.green_secondary};
  }
  .header--last-col{
    display: flex;
    align-items: center;
  }
  .white--menu .rounded--cta:hover{
    background-color: #fff;
    color: #000;
  }
  .menu-desk--bg{
    position: fixed;
    top: 0;
    height: 100%;
    width: 100%;
    pointer-events: none;
    opacity: 0;
    transition: opacity .05s ease-out;
    background-color: #fff;
  }
  .menu-desk--bg.show{
    opacity: 1;
  }
  .back-to-3d {
    display: flex;
    align-items: center;
    cursor: pointer;
    img {
      margin-right: 24px;
    }
  }
  @media screen and (max-width: 767px){
    .header--logo-wrap img.logo{
      width: 104px;
    }
  }
`;

export {
  StyledHeader,
};

